import { useTranslation } from 'react-i18next';
import { Dropdown, SimpleSelectList } from '#components/Input/Dropdown';
import { ResultsPerPageWrapper } from './styles';

type ResultsPerPageProps = {
  totalRows: number;
  pageSize: number;
  onChange: (newPageSize: number) => void;
};

export const resultsPerPageOptions = (totalRows: number) => {
  const options = [10, 20, 50, 100];
  const minimumResultsPerPage = Math.min(...options);

  // remove options that are greater than totalRows, except for the minimumResultsPerPage
  return options.filter((opt) => opt <= totalRows || opt === minimumResultsPerPage);
};

export const ResultsPerPage = ({ totalRows, pageSize, onChange }: ResultsPerPageProps) => {
  const { t } = useTranslation();
  const options = resultsPerPageOptions(totalRows);

  return (
    <ResultsPerPageWrapper>
      {t('table.pagination.results-per-page')}{' '}
      <Dropdown
        onChange={(values: string[]) => {
          onChange(Number(values[0]));
        }}
        items={options.map((opt) => ({
          children: [],
          label: opt.toString(),
          type: 'value',
          value: opt.toString(),
        }))}
        placeholder={pageSize.toString()}
        selectedValues={[pageSize.toString()]}
        disabled={options.length === 1}
        aria-label="Select rows per page"
      >
        <SimpleSelectList />
      </Dropdown>
    </ResultsPerPageWrapper>
  );
};
